import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';
import {
  Company,
  Country,
  Currency,
  InvoiceLine,
  Order,
  User,
  Vessel,
} from './models';

export class Invoice extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'invoices';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      number: this.attr(null),
      reference_no: this.attr(null),
      order_id: this.attr(null),
      order: this.belongsTo(Order, 'order_id'),
      currency_code: this.attr(null),
      currency: this.belongsTo(Currency, 'currency_code', 'code'),
      issued_at: this.attr(null),
      notes: this.attr(null),
      client_company_id: this.attr(null),
      client_company: this.belongsTo(Company, 'client_company_id'),
      client_contact_user_id: this.attr(null),
      client_contact_user: this.belongsTo(User, 'client_contact_user_id'),
      client_address: this.attr(null),
      client_city: this.attr(null),
      client_postal_code: this.attr(null),
      client_country_code: this.attr(null),
      client_country: this.belongsTo(Country, 'client_country_code', 'code'),
      updated_at: this.attr(null),
      created_at: this.attr(null),
      sent_at: this.attr(null),
      sent_to: this.attr(null),
      invoice_lines: this.hasMany(InvoiceLine, 'invoice_id'),
      job_cargo_vessel: this.attr(null),
      vessel: this.belongsTo(Vessel, 'job_cargo_vessel'),
      total_amount: this.attr(null),
      footer_note: this.attr(null),
      due_at: this.attr(null),
    };
  }

  get status() {
    return this.sent_at ? 'Sent' : 'Pending';
  }
}

export default Invoice;
